<template>
  <div style="padding: 20px; line-height: 1.2">
    <p style="line-height: 16pt; margin: 7.8pt 0pt 0pt; text-align: center">
      <span style="font-family: 微软雅黑; font-size: 16pt; font-weight: bold">
        腾宇一号用户服务条款
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="color: #999999; font-family: 宋体; font-size: 10pt">
        &#xa0;
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt; text-indent: 21pt">
      <span style="font-family: 宋体; font-size: 10pt">您在使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务前，应当仔细认真阅读本《
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        用户服务条款》(下称“
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        本条款
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        ”)中的全部规则的内容（
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        特别是其中以加粗及/或加下划线标示出的关于
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号平台
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        服务及用户重大权益的规则，该等规则可能涉及相关方的责任免除或限制、法律适用与争议解决条款，请您重点阅读
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        ），确认对本条款及各项服务规则均已知晓、理解并接受，并已同意将其作为确定双方权利义务的依据。
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        如您使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        账号访问
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号平台
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        或以其他方式使用或接受
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        的任何服务，即视为您已阅读并与
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        达成协议，自愿接受本条款及服务规则的所有内容的约束。所有服务规则视为本条款不可分割的一部分
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        ，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        与本条款具有同等法律效力。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">本条款的签约双方为</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">服务的实际运营商</span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        深圳腾宇一号科技有限公司
      </span>
      <span style="font-family: 宋体; font-size: 10pt">（以下称“</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">”）</span>
      <span style="font-family: 宋体; font-size: 10pt">与使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        相关服务的使用人（下称“
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        用户
      </span>
      <span style="font-family: 宋体; font-size: 10pt">”或“</span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        您
      </span>
      <span style="font-family: 宋体; font-size: 10pt">”），本条款是您与</span>
      <span style="font-family: 宋体; font-size: 10pt">泽宇教育</span>
      <span style="font-family: 宋体; font-size: 10pt">之间关于您使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        提供的各项服务所订立的服务条款，具有正式书面合同的效力。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">本条款</span>
      <span style="font-family: 宋体; font-size: 10pt">与</span>
      <span style="font-family: 宋体; font-size: 10pt">《隐私政策》</span>
      <span style="font-family: 宋体; font-size: 10pt">互为</span>
      <span style="font-family: 宋体; font-size: 10pt">的必要组成部分。</span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        如本条款与《
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        隐私政策
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        》文本内容存在冲突之处，则以时间上最新发布的内容为准，发布时间相同的，以本条款为准。本条款有待明确、存在歧义或未规定之处均以《
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        隐私政策
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        》中的规定为准。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        您理解并同意，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号平台
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        将根据《
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        隐私政策
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        》的约定，对本条款或各项服务规则不时地进行修改更新。修改更新内容的发布和实施均适用《
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        隐私政策
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        》的相关约定。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        &#xa0;
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        定义
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt">：指是</span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      ></span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        深圳腾宇一号科技有限公司
      </span>
      <span style="font-family: 宋体; font-size: 10pt">运营的【</span>
      <span style="font-family: 宋体; font-size: 10pt">创业营销信息</span>
      <span style="font-family: 宋体; font-size: 10pt">】平台。</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        运用自己的平台系统，通过互联网络等方式为用户提供
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        问卷调查、客户信息采集、销售记录追踪、成功案例分享
      </span>
      <span style="font-family: 宋体; font-size: 10pt">等网络服务。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        问卷云
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        ：
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        是指根据本条款及其他适用的服务规则，在
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">平台上</span>
      <span style="font-family: 宋体; font-size: 10pt">向不特定群体</span>
      <span style="font-family: 宋体; font-size: 10pt">发布</span>
      <span style="font-family: 宋体; font-size: 10pt">问卷</span>
      <span style="font-family: 宋体; font-size: 10pt">信息</span>
      <span style="font-family: 宋体; font-size: 10pt">
        ，进行客户偏好收集的服务
      </span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        销售云
      </span>
      <span style="font-family: 宋体; font-size: 10pt">：是指通过</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">平台，</span>
      <span style="font-family: 宋体; font-size: 10pt">
        记录、追踪营销流程及客户营销状态
      </span>
      <span style="font-family: 宋体; font-size: 10pt">等</span>
      <span style="font-family: 宋体; font-size: 10pt">信息的服务</span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        案例云
      </span>
      <span style="font-family: 宋体; font-size: 10pt">：是指</span>
      <span style="font-family: 宋体; font-size: 10pt">用户</span>
      <span style="font-family: 宋体; font-size: 10pt">通过</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">发布的</span>
      <span style="font-family: 宋体; font-size: 10pt">个人成功案例</span>
      <span style="font-family: 宋体; font-size: 10pt">等内容</span>
      <span style="font-family: 宋体; font-size: 10pt">
        ，复盘成功流程、分享成功经验的服务
      </span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        5、交互信息服务
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        ：交互信息服务是指用户在
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        腾宇一号案例云
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        平台上发布
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        的
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        文字、图片、视频等信息
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        ，可以被其他用户浏览、点评的服务
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: normal">
        。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        一、用户账号
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        1、在注册、管理、使用账号时，您应遵循诚实信用、合法善意的原则。您向平台提交的相关注册资料应当遵守法律法规、社会主义制度、国家利益、公民合法权益、公序良俗、信息真实等原则，不应提交任何违法或不良信息。相关资料如有变动，您应及时更新。如果因您所提供的注册资料不合法、不真实、不准确或未及时更新，从而导致相关法律责任或不利后果的，您将承担相应的法律责任及不利后果。同时，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权拒绝为您提供注册服务。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        2、您同意并承诺以合法、合规、合理的方式使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">账号：</span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （1）您设置的账号昵称、头像及个人介绍等个人资料不得出现违法和不良信息，包括但不限于使用政治、色情、低俗、侮辱、诽谤等违反法律、道德及公序良俗的词语。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （2）未经他人许可，您不得使用他人名义（包括但不限于冒用他人姓名、名称、字号、头像、身份等或采取其他足以让人引起混淆的方式）开设
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">账号。</span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （3）不得假冒、仿冒、捏造党政军机关、企事业单位、新闻媒体等组织机构名称、标识信息或采取其他足以让人引起混淆的方式开设
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">账号。</span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （4）您不得恶意注册
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        账号（包括但不限于频繁注册、批量注册账号等行为）或将
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        账号用于非法或不正当用途（包括但不限于流量作假等行为），不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为，不得采取各种技术手段恶意绕开或者对抗平台规则。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        3、您应妥善保管账号信息、账号密码以及其他与账号相关的信息、资料。您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任，包括但不限于您在
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        平台进行的任何信息发表、浏览点击等操作行为可能引起的一切法律责任。若发现他人未经许可使用您的账号或发生其他任何安全漏洞问题时，您应当立即通知
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="margin: 7.8pt 0pt 5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        4、您理解并同意，如您违反上述条款，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权对您采取禁止注册、删除或屏蔽违法违规信息、不同时限的禁止信息发布、封号等处置措施。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        5、您理解并同意，您可通过注册新的账号或登录您现有的账号以使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        的各项服务及功能，您使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">账号应同时遵守《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">》中的各项规定。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        二、用户管理
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、您知悉、理解并同意，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号平台
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        服务过程中，可能涉及收集、存储、使用、共享和保护用户个人信息。在您使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        提供的服务时，您同意
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        依据《
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        隐私政策
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        》的规定执行相关个人信息的收集、使用和共享。您进一步同意，就
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台所产生的与个人信息使用紧密相关的交易，您授权
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        使用或允许
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        许可的第三方在必要、合理的限度内使用您的个人信息，包括但不限于身份信息、账号信息、交易信息等。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、您知悉并同意，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        将按照有权网络信息主管部门的相关规定对您的账号信息及所发布的各项信息进行必要的安全审查及评估，保留并向有关部门定期报送您的账号信息及您所发布的各项信息。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">用户有权在</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        平台上发布客观、真实的
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        问卷调查、案例分享，以及
      </span>
      <span style="font-family: 宋体; font-size: 10pt">文字点评、图片点评</span>
      <span style="font-family: 宋体; font-size: 10pt">等</span>
      <span style="font-family: 宋体; font-size: 10pt">
        。用户同意并理解，为了遵守法律法规和政策，维护良好的平台秩序，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权对特定用户、特定行业
      </span>
      <span style="font-family: 宋体; font-size: 10pt">、</span>
      <span style="font-family: 宋体; font-size: 10pt">
        特定服务的点评信息或者
      </span>
      <span style="font-family: 宋体; font-size: 10pt">用户</span>
      <span style="font-family: 宋体; font-size: 10pt">
        信息发布流程作出特别设定或者限制。用户有权发表符合国家法律规定，并符合
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">规则的文章及观点。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        您可以通过正式的页面公告和/或站内信和/或电子邮件和/或客服电话和/或手机短信、常规的信件接收和查看
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        腾宇一号平台的公告、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">活动或信息。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        5、
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        用户确认已经仔细阅读并充分理解和自愿同意
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号《用户协议》及《隐私政策》
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        的全部规定。在发布信息时，您应确保该等信息的真实性、客观性、合法性，
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        提倡用户贡献高质量
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        案例分享
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        。用户应确保在
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        上发
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        布
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        的各类
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        问卷信息、案例分享及点评
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        均不涉及侵犯第三方隐私、著作权或其他合法权益。用户需维护点评的客观性，不得利用
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        用户身份进行任何违反法律、法规、国家政策以及诚实信用原则的行为，包括但不限于：
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        （1）违反法律法规及国家政策的行为：
      </span>
    </p>
    <ul style="margin: 0pt; padding-left: 0pt" type="disc">
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          反对宪法所确定的基本原则的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          损害国家荣誉和利益的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          煽动民族仇恨、民族歧视，破坏民族团结的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          破坏国家宗教政策，宣扬邪教和封建迷信的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          散布谣言，扰乱经济秩序和社会秩序的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
          法律、行政法规禁止的其他内容。
        </span>
      </li>
    </ul>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        （2）违反诚实信用原则的行为：
      </span>
    </p>
    <ul style="margin: 0pt; padding-left: 0pt" type="disc">
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          炒作并向
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          潜在客户
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          收取费用或获取利益；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          为获得利益或好处，参与或组织撰写及发布虚假点评；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          以虚构事实、侮辱、诽谤等方式恶意诋毁
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          腾宇一号及其他用户
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          的商誉；
        </span>
      </li>
      <li
        style="
          font-family: serif;
          font-size: 10pt;

          margin: 7.8pt 0pt 0pt 9.6pt;
          padding-left: 8.4pt;
          text-indent: 0pt;
        "
      >
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          进行其他影响点评客观、扰乱
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          腾宇一号平台
        </span>
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          正常秩序的违规行为等。
        </span>
      </li>
    </ul>
    <p style="margin: 7.8pt 0pt 0pt">
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        如您存在以上行为的，
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        有权采取如下行动：
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 18pt">
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ①违规信息将作屏蔽，视情节轻重发出警告；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 18pt">
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ②清除其所有点评、图片
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        及信息，
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        屏蔽其发布的涉及商业性炒作的
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        各类文案
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 18pt">
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ③暂时限制/永久限制您使用账号在
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        平台上发布信息；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 18pt">
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ④法律、行政法规、本条款及《
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        隐私政策
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        》规定的其他方式。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        6、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">禁止用户将</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        以任何形式作为从事各种非法活动的场所、平台或媒介。未经
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        的授权或许可，用户不得借用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        的名义从事任何商业活动，也不得以任何形式将
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        作为从事商业活动的场所、平台或媒介。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        7、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">您违反本条款、《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">》或</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        不时发布的任何服务规则，
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        则
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        有权在法律允许的范围内采取一切必要的措施，包括但不限于删除用户发布的内容、取消用户在
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号发布信息、点评的权限
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ，暂停或终止您使用
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号平台
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        ，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">给</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        造成损失的，您应负全部赔偿责任，包括且不限于财产损害赔偿、名誉损害赔偿、诉讼费、律师费、公证费、交通费等因维权而产生的合理费用。
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">有权按照本条款及《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">
        》的相关规定对您的行为进行处理。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        三
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、交互信息服务特别约定
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        您应确保具有相应的资格并符合在
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        开展交互信息服务的相应条件。
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        如果因为您不具备相应资格或者条件的情形下通过
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台发布信息而引发任何法律责任，您应自行承担。因此给
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台造成损失的，您应予以全额赔偿。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        平台有可能在相关法律法规和政策的指引下，对交互信息服务实施分级分类管理，建立发布者信用等级管理体系，建立黑名单管理制度等。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">用户在</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        平台发布的文字、图片、视频等信息均应遵守相关法律法规、规章、本条款及《
      </span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">》的相关规定。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        您同意：如出现以下任一情形的，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        将视情节轻重采取删除信息、限制交互平台使用功能、停止您的账号使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">等处理措施：</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （1）发布违反相关法律法规、规章、政策之规定或者违反本条款及相关服务规则的信息；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （2）发布与主题无关的信息或评论，包含文字、图片、视频等；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （3）发布可能存在交易风险的外部网站和APP信息，如发布社交、团购等外部网站或APP的名称、超链接、二维码等信息；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （4）发布的视频违反国家法律法规的相关要求，包括但不限于《广播电视管理条例》、《电影管理条例》、《互联网视听节目服务管理规定》、《广电总局关于加强互联网视听节目内容管理的通知》等的相关要求；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">（5）用户</span>
      <span style="font-family: 宋体; font-size: 10pt">如需通过</span>
      <span style="font-family: 宋体; font-size: 10pt">表演（直播）</span>
      <span style="font-family: 宋体; font-size: 10pt">等方式进行案例分享</span>
      <span style="font-family: 宋体; font-size: 10pt">时</span>
      <span style="font-family: 宋体; font-size: 10pt">，</span>
      <span style="font-family: 宋体; font-size: 10pt">
        违反国家法律法规的相关要求，包括但不限于《互联网文化管理暂行规定》、《互联网直播服务管理规定》等的相关要求；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">（6）其他违反</span>
      <span style="font-family: 宋体; font-size: 10pt">本条款</span>
      <span style="font-family: 宋体; font-size: 10pt">及《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">》相关规定的情形。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        &#xa0;
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        四
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、服务终止
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        您同意
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        有权随时修改或中断其向您提供的任何免费服务而无需事先通知您。您与
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        进行的有偿交易，您同意
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        有权在事先通知的情况下予以修改、中断，并按照公平、诚实信用、等价有偿的原则处理后续事宜。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        如您的账号同时符合以下条件，则
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权利终止您通过账号使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        。这将导致您的账号不能再登录
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        ，相应服务亦同时终止：
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 10.5pt">
      <span style="font-family: 宋体; font-size: 10pt">（一）连续</span>
      <span style="font-family: 宋体; font-size: 10pt">十二个</span>
      <span style="font-family: 宋体; font-size: 10pt">月未登录；</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 10.5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （二）不存在未到期的有效业务；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 10.5pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （三）终止您的账号和服务的行为不违反相关法律法规的强制性规定。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        如您对本条款及其不时修订有任何异议的，您有权停止使用
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        的各项服务，或通过客服等渠道告知
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        停止对您提供服务。停止服务后，除法律法规另有明确规定外，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权（但无义务）保留您的账号访问
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        的相关信息和数据，或留存、转发任何账号内的任何站内信或短消息。在此情况下，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        没有义务（但有权利）向您或代为向其他第三方传送任何未处理的信息或未完成的服务或交易信息。您同意
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">不就终止</span>
      <span style="font-family: 宋体; font-size: 10pt">平台</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务而对您或任何第三方承担任何责任。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">您同意，您与</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">的合同关系终止后，</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">就您在使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务期间存在违法行为或违反本条款和／或其他服务规则的行为的，仍可依据本条款向您主张权利。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        &#xa0;
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        五
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、知识产权及其它权利
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        平台及相关服务的运营系统由
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        自主开发、运营并提供技术支持
      </span>
      <span style="font-family: 宋体; font-size: 10pt">，</span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      ></span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        深圳腾宇一号科技有限公司
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      ></span>
      <span style="font-family: 宋体; font-size: 10pt">对</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务的开发和运营等过程中产生的所有数据和信息等享有全部权利。
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        提供各项服务时所依托软件的著作权、专利权，所使用的各项商标、商业形象、商业标识、技术诀窍，其著作权、商标权及其他各项相关权利均归
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      ></span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        深圳腾宇一号科技有限公司
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      ></span>
      <span style="font-family: 宋体; font-size: 10pt">所有。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">您理解并同意，</span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        您在
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        腾宇一号
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        发表的各项点评信息、文章、视频、反馈意见等所有信息及其衍生品的知识产权及所有权，适用《
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        隐私政策
      </span>
      <span
        style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
      >
        》中的相关约定
      </span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        六
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、免责事由
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、 除非
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        以书面形式明确约定，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        对于用户以任何方式（包括但不限于包含、经由、连接或下载）从
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        所获得的任何由
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        其他用户
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        发布的内容信息，包括但不限于
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        数据分析、案例分享
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、点评内容等，不保证其准确性、完整性、可靠性。用户应当自行审核判断相关信息，并对于用户因
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        上的内容信息而购买、获取的任何产品、服务、信息或资料自行承担责任和风险。用户因此受损的，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        在法律允许的最大范围内予以免责。
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        内所有用户所发表的用户点评、
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        数据分析、案例
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        信息等，仅代表用户个人观点，并不表示
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        赞同其观点或证实其描述，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        在法律允许的最大范围内予以免责。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        2、您同意并理解，针对
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        其他用户
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        向您销售/提供的商品/服务，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        并非您所购买的具体商品或者服务的生产者和销售者。您同意，针对该等商品或者服务以及相关售后服务中所产生的任何矛盾和纠纷均不应针对
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        提出。在法律允许的范围内，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        不对上述商品/服务承担包括解释说明、赔偿在内的任何责任
      </span>
      <span style="font-family: 宋体; font-size: 10pt">。</span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        对于
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台中明确标注为自营的商品/服务，适用
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号平台
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        的相应服务规则。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、您在
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台上传、发布任何信息或者内容的，应当自行保留备份。
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        不对用户所发布信息的保存、修改、删除或储存失败负责，对
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        上的非因
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        故意所导致的排字错误、疏忽等不承担责任。
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        有权但无义务，改善或更正
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        任何部分之疏漏、错误。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        有权在法律允许范围内，在不通知您的情况下删除任何用户发布的不符合本条款
      </span>
      <span style="font-family: 宋体; font-size: 10pt">、</span>
      <span style="font-family: 宋体; font-size: 10pt">《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">
        》以及法律规定的信息。
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        将不对删除该等信息给您造成的不便或损失承担任何责任。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        5、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">
        您同意，在法律许可范围内，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        在任何情况下都不对任何个人或实体的直接、间接、偶然、特殊、惩罚性的损害或其他损害
      </span>
      <span style="font-family: 宋体; font-size: 10pt">、</span>
      <span style="font-family: 宋体; font-size: 10pt">
        损失承担责任，这些损害或损失包括但不限于：
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 11.25pt">
      <span style="font-family: 宋体; font-size: 10pt">
        （1）您理解并同意，由于互联网的特殊性造成的
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        显示的信息所存在的滞后性或差错，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        对此不承担任何责任；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 11.25pt">
      <span style="font-family: 宋体; font-size: 10pt">（2）您在使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务中，因第三方原因使您遭受侮辱、诽谤、不作为、淫秽、色情或亵渎事件，
      </span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        在法律允许的范围内不承担法律责任；
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt 11.25pt">
      <span style="font-family: 宋体; font-size: 10pt">（3）《</span>
      <span style="font-family: 宋体; font-size: 10pt">隐私政策</span>
      <span style="font-family: 宋体; font-size: 10pt">
        》中规定其他不可抗力及免责事由。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        &#xa0;
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        七
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、争议解决
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        1、您同意并理解，如您因通过
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        平台购买的任何商品或者服务产生任何纠纷的，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        可在法律法规要求的范围内协助您与争议对方进行协商调解。您同意，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        有权向争议双方了解情况，并将所了解的情况通过必要方式通知对方。但您理解并同意，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        腾宇一号
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        无任何义务对您与商家之间的任何争议承担任何责任。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        3、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">若您与</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        因本条款内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        任何一方均可向
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        泽宇教育注册地
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        有管辖权的人民法院提起诉讼。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        4、
      </span>
      <span style="font-family: 宋体; font-size: 10pt">因您使用</span>
      <span style="font-family: 宋体; font-size: 10pt">腾宇一号</span>
      <span style="font-family: 宋体; font-size: 10pt">
        服务而引起或与之相关的一切争议、权利主张或其它事项，均适用中华人民共和国大陆地区法律，并且排除一切冲突法规定的适用。
      </span>
    </p>
    <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        &#xa0;
      </span>
    </p>
    <!-- <p style="margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        八
      </span>
      <span style="font-family: 宋体; font-size: 10pt; font-weight: bold">
        、意见及反馈
      </span>
    </p>
    <p style="line-height: 12pt; margin: 7.8pt 0pt 0pt">
      <span style="font-family: 宋体; font-size: 10pt">
        用户如有任何需要说明条款的要求，请造访
      </span>
      <a href="" style="color: #000000">
        <span
          style="font-family: 宋体; font-size: 10pt; text-decoration: underline"
        >
          【联系我们】
        </span>
      </a>
      <span style="font-family: 宋体; font-size: 10pt">致电说明。</span>
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p>
    <p
      style="margin: 7.8pt 0pt 10pt; orphans: 0; text-align: justify; widows: 0"
    >
      <span style="font-family: 宋体; font-size: 10pt">&#xa0;</span>
    </p> -->
  </div>
</template>
